module.exports = __webpack_public_path__ + "static/industrial-rewilding-4e3261543da8292abd070fa9611aa848.jpg";